import packageJson from '@ld.consumer-portal/package-json';

/**
 * Web bundle version of the running code. Injected into package.json at build
 * time from the latest `v*` git tag, and the version the OTA bundle is published
 * under. Inside a native binary this is the builtin bundle version.
 */
export const WEB_BUNDLE_VERSION: string = packageJson.version;

/**
 * Marketing app version displayed to users and used for force-update checks.
 *
 * Format is `YYYY.RELEASE.PATCH` (e.g. `2026.2.0`) and is bumped **manually**
 * in a PR. The mobile pipelines read this value and inject it into the native
 * version fields (Android `versionName`, iOS marketing version), so the stores
 * and the app UI always report the same number. It is intentionally independent
 * of WEB_BUNDLE_VERSION above.
 *
 * When bumping this value, also update the Firebase Remote Config
 * `min_app_version_ios` / `min_app_version_android` values, which are compared
 * against it by ForceUpdateService.
 */
export const NATIVE_APP_VERSION = '2026.2.0';
